import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from 'src/modules/base/services/translate.service';
import { SidebarNavHelper } from '../app-sidebar-nav.service';

@Component({
    selector: 'app-sidebar-nav-label, cui-sidebar-nav-label',
    templateUrl: './app-sidebar-nav-label.component.html',
    standalone: false
})
export class AppSidebarNavLabelComponent implements OnInit {
  @Input() item: any;

  private classes = {
    'nav-label': true,
    'active': true
  };
  private iconClasses = {};

  constructor(
    public helper: SidebarNavHelper,
    public translateService: TranslateService
  ) { }

  ngOnInit() {
    this.iconClasses = this.helper.getIconClass(this.item);
  }

  getItemClass() {
    const itemClass = this.item.class;
    this.classes[itemClass] = !!itemClass;
    return this.classes;
  }

}
